import { render, staticRenderFns } from "./PublicSettings.vue?vue&type=template&id=1be5cbce&"
import script from "./PublicSettings.vue?vue&type=script&lang=js&"
export * from "./PublicSettings.vue?vue&type=script&lang=js&"
import style0 from "./PublicSettings.vue?vue&type=style&index=0&id=1be5cbce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports